module.exports = __webpack_public_path__ + "media/images/image-dded746c.png";